import { useTranslation } from 'react-i18next'

import type { PanelBulkUserArchiveResponse } from '@/api/v1/generated-api.gen'
import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { toast } from '@/hooks/useToast'

const useBulkArchiveUsersMutation = ({
  onSuccess,
  onError
}: {
  onSuccess: (data: PanelBulkUserArchiveResponse) => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: { ids: string[] }) =>
      httpService.panel.panelUsersBulkArchiveCreate({
        users_ids: data.ids
      }),
    onSuccess,
    onError
  })

const useBulkArchiveUsers = ({
  onSuccess,
  onError,
  userName
}: {
  onSuccess: () => void
  onError: () => void
  userName?: string
}) => {
  const { t } = useTranslation('users')

  return useBulkArchiveUsersMutation({
    onSuccess: ({ successfully_archived, unsuccessfully_archived }) => {
      if (successfully_archived > 0) {
        toast({
          variant: 'success',
          title: userName
            ? t('toast.user-archived', {
                NAME: userName
              })
            : t('toast.users-archived', {
                count: successfully_archived
              })
        })
      }
      if (unsuccessfully_archived > 0) {
        toast({
          variant: 'error',
          title: userName
            ? t('toast.user-archived-failed', {
                NAME: userName
              })
            : t('toast.users-archived-failed', {
                count: unsuccessfully_archived
              })
        })
      }
      onSuccess()
    },
    onError
  })
}

export default useBulkArchiveUsers
